function About(){


    return <>
    <div id='displayAbout'>
        <h1>Git: https://github.com/ignatandrei/Blocklyautomation</h1>
        <h1>Demo : https://ignatandrei.github.io/BlocklyAutomation/automation/main</h1>
    </div>
    </>
}

export default About;